/**
 * React Native Gesture Handler Web Polyfill
 * Provides stub implementations for react-native-gesture-handler on web
 * Most gesture handling on web is done through standard DOM events
 */
import React from 'react';

// Stub gesture handler components that just render children in a div
export const GestureHandlerRootView: React.FC<any> = ({ children, style, ...props }) => {
  return React.createElement('div', { style, ...props }, children);
};

export const GestureDetector: React.FC<any> = ({ children }) => children;
export const Gesture = {} as any;
export const GestureType = {} as any;

// Export commonly used gesture components as pass-through wrappers
export const PanGestureHandler: React.FC<any> = ({ children }) => children;
export const TapGestureHandler: React.FC<any> = ({ children }) => children;
export const LongPressGestureHandler: React.FC<any> = ({ children }) => children;
export const RotationGestureHandler: React.FC<any> = ({ children }) => children;
export const PinchGestureHandler: React.FC<any> = ({ children }) => children;
export const FlingGestureHandler: React.FC<any> = ({ children }) => children;
export const ForceTouchGestureHandler: React.FC<any> = ({ children }) => children;

// Touchable components - render as divs with onClick handlers
export const TouchableOpacity: React.FC<any> = ({ children, onPress, style, ...props }) => {
  return React.createElement(
    'div',
    {
      onClick: onPress,
      style: { cursor: onPress ? 'pointer' : 'default', ...style },
      ...props,
    },
    children
  );
};

export const TouchableHighlight = TouchableOpacity;
export const TouchableWithoutFeedback = TouchableOpacity;
export const TouchableNativeFeedback = TouchableOpacity;

// Swipeable stub
export const Swipeable: React.FC<any> = ({ children }) => {
  return React.createElement('div', null, children);
};

// State and constants
export const State = {
  UNDETERMINED: 0,
  FAILED: 1,
  BEGAN: 2,
  CANCELLED: 3,
  ACTIVE: 4,
  END: 5,
};

export const Directions = {
  RIGHT: 1,
  LEFT: 2,
  UP: 4,
  DOWN: 8,
};

// Default export
export default {
  GestureHandlerRootView,
  GestureDetector,
  Gesture,
  PanGestureHandler,
  TapGestureHandler,
  LongPressGestureHandler,
  RotationGestureHandler,
  PinchGestureHandler,
  FlingGestureHandler,
  ForceTouchGestureHandler,
  TouchableOpacity,
  TouchableHighlight,
  TouchableWithoutFeedback,
  TouchableNativeFeedback,
  Swipeable,
  State,
  Directions,
};
